import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { TbCheck, TbLetterX } from 'react-icons/tb';

const ToggleButton = ({ isOff, onClick, enabled = true }) => {
  const baseButtonStyles = {
    borderWidth: 0,
    borderStyle: 'none',
    transition: 'background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease',
    cursor: enabled ? 'pointer' : 'default',
    flex: '1 1 0',
    borderRadius: 0,
  };

  const activeSuccess = {
    ...baseButtonStyles,
    backgroundColor: '#1e7c4a',
    borderColor: '#17633a',
    color: '#ffffff',
    boxShadow: '0 0 10px rgba(30, 124, 74, 0.55)',
  };
  const inactiveSuccess = {
    ...baseButtonStyles,
    backgroundColor: '#14532d',
    borderColor: '#0f3d23',
    color: '#bbf7d0',
  };

  const activeDanger = {
    ...baseButtonStyles,
    backgroundColor: '#c53030',
    borderColor: '#8f1f1f',
    color: '#ffffff',
    boxShadow: '0 0 10px rgba(197, 48, 48, 0.55)',
  };
  const inactiveDanger = {
    ...baseButtonStyles,
    backgroundColor: '#7f1d1d',
    borderColor: '#661212',
    color: '#fca5a5',
  };

  const enableStyles = isOff ? inactiveSuccess : activeSuccess;
  const disableStyles = isOff ? activeDanger : inactiveDanger;

  const commonButtonProps = {
    className: 'toggle-button px-3 d-flex align-items-center justify-content-center fw-semibold',
    disabled: !enabled,
  };

  return (
    <ButtonGroup className="toggle-button-group shadow-sm rounded overflow-hidden border-0 bg-dark d-flex w-auto">
      <Button
        {...commonButtonProps}
        style={disableStyles}
        onClick={() => enabled && !isOff && onClick()}
        variant="light"
      >
        <TbLetterX size={18} />
      </Button>
      <Button
        {...commonButtonProps}
        style={enableStyles}
        onClick={() => enabled && isOff && onClick()}
        variant="light"
      >
        <TbCheck size={18} />
      </Button>
    </ButtonGroup>
  );
};

export default ToggleButton;
